import React from 'react';

export default function OptGroup(props) {
    return (
        <optgroup label={props.name}>{props.options}</optgroup>
    );
}